import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const EmployeeLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // All non-admin roles (employee, team-leader, hod) use the same /employee shell and dashboard.
  const appPathPrefix = 'employee';

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="employee-layout">
      {!sidebarOpen && (
        <button 
          className="mobile-menu-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          ☰
        </button>
      )}
      {sidebarOpen && (
        <div 
          className="mobile-menu-overlay active"
          onClick={closeSidebar}
        />
      )}
      <Sidebar userRole={appPathPrefix} isOpen={sidebarOpen} onClose={closeSidebar} />
      <Topbar userRole={appPathPrefix} />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default EmployeeLayout;

